var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 16,
    height: 2,
    rx: 1,
    transform: "rotate(-45 5 17)",
    fill: "#23273B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65617 6.66023C6.0467 6.26971 6.67986 6.26971 7.07039 6.66023L16.9699 16.5597C17.3604 16.9503 17.3604 17.5834 16.9699 17.9739C16.5794 18.3645 15.9462 18.3645 15.5557 17.9739L5.65617 8.07445C5.26565 7.68392 5.26565 7.05076 5.65617 6.66023Z",
    fill: "#23273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.ae6264d1248e0988ef536ae2fa4ca081.svg";
export { ForwardRef as ReactComponent };